export class RemoveAssignmentPropiedadPropietarioRequest {

    public id_Propiedad: number = 0;
    public id_Propietario: number = 0;
}
